import React, { useState, useEffect, useRef } from "react";
import { useParams } from "react-router";
import { Link } from "react-router-dom";
import "./OpenStory.css";
import { fetchPublicStories } from "../../../config/data";
import EmptyList from "../../Common/EmptyList/EmptyList";
import cover1 from "../../assets/images/Synthwave-Postmodern.jpg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faThumbsUp } from "@fortawesome/free-solid-svg-icons";
import { faWhatsapp, faTwitter, faApple } from "@fortawesome/free-brands-svg-icons";
import axios from "axios";
import { config } from "../../../config/const";
import Rating from "@mui/material/Rating";
import Typography from "@mui/material/Typography";
import "@fortawesome/fontawesome-free/css/all.min.css";
import { useReactToPrint } from "react-to-print";
import jsPDF from "jspdf";
import CommentSection from "../../Common/Comments/CommentSection";
import { toast } from "react-toastify";

const OpenStory = () => {
  const { id } = useParams();
  const [story, setStory] = useState(null);
  const [loading, setLoading] = useState(true);
  const [liked, setLiked] = useState(false);
  const [likes, setLikes] = useState(0);
  const [value, setValue] = useState(0);

  const storyRef = useRef();
  const email = localStorage.getItem("email");

  const checkLikedStatus = async () => {
    const email = localStorage.getItem("email");
    try {
      const response = await axios.get(`${config.backend_url}/user/checkLike`, {
        params: { story_id: id, email },
      });
      setLiked(response.data.isLiked);
    } catch (err) {
        console.log(err);
    }
  };

  const fetchStoryDetails = async () => {
    try {
      setLoading(true);
      const baseUrl = config?.backend_url || 'http://localhost:3002';
      
      const response = await axios.get(`${baseUrl}/user/story/${id}`);
      
      // Response should not be wrapped in a 'story' object anymore
      const storyData = response.data.story;
      
      if (!storyData) {
        toast.error('Story not found');
        return;
      }

      setStory(storyData);
      setLikes(storyData.likes || 0);

      // Add view after successfully setting story
      await axios.post(`${baseUrl}/user/addView`, { story_id: id });

    } catch (error) {
      console.error('Error details:', {
        message: error.message,
        response: error.response?.data,
        status: error.response?.status
      });
      toast.error('Failed to load story');
    } finally {
      setLoading(false);
    }
  };

  const getRating = async () => {
    const email = localStorage.getItem("email");
    try {
      const response = await axios.get(
        `${config.backend_url}/user/getStoryRating`,
        { params: { story_id: id, email } }
      );
      const response2 = await axios.get(
        `${config.backend_url}/user/getUserRating`,
        { params: { story_id: id, email } }
      );
      setValue(response2.data.rating);
    } catch (err) {
      console.log(err);
    }
  };

  const setRating = async (value) => {
    const email = localStorage.getItem("email");
    try {
      await axios.post(`${config.backend_url}/user/addRating`, {
        story_id: id,
        email,
        rating: value,
      });
    } catch (err) {
      console.log(err);
    }
  };

  const handlePrint = useReactToPrint({
    content: () => storyRef.current,
    documentTitle: story ? story.title : "Story",
  });

  const handleExportPDF = () => {
    const pdf = new jsPDF("p", "pt", "a4");
    pdf.html(storyRef.current, {
      callback: (doc) => doc.save(`${story.title}.pdf`),
      margin: [20, 20, 20, 20],
      autoPaging: true,
    });
  };

  useEffect(() => {
    if (id) {
      fetchStoryDetails();
      checkLikedStatus();
      getRating();
    }
  }, [id]);

  const toggleLike = () => {
    setLiked(!liked);
    axios.post(`${config.backend_url}/user/postLike`, {
      story_id: id,
      email: localStorage.getItem("email"),
    });
    setLikes(liked ? likes - 1 : likes + 1);
  };

  const currentUrl = window.location.href;

  return (
    <>
      <Link className="story-goBack" to="/">
        <span> &#8592;</span> <span>Go Back</span>
      </Link>
      {loading ? (
        <div className="loading-container">
          <div className="loader"></div>
          <p>Loading story...</p>
        </div>
      ) : story ? (
        <div className="story-wrap" ref={storyRef}>
          <header>
            <h1>{story.title}</h1>
            <p className="story-author">
              Published by {story.user?.name || "Unknown"} on{" "}
              {(() => {
                const date = new Date(story.publishingDate);
                const day = date.getDate();
                const monthNames = [
                  "January",
                  "February",
                  "March",
                  "April",
                  "May",
                  "June",
                  "July",
                  "August",
                  "September",
                  "October",
                  "November",
                  "December",
                ];
                const month = monthNames[date.getMonth()];
                const year = date.getFullYear();
                const getOrdinalSuffix = (day) => {
                  if (day > 3 && day < 21) return "th";
                  switch (day % 10) {
                    case 1:
                      return "st";
                    case 2:
                      return "nd";
                    case 3:
                      return "rd";
                    default:
                      return "th";
                  }
                };
                return `${day}${getOrdinalSuffix(day)} ${month} ${year}`;
              })()}
            </p>
          </header>
          <img alt="story cover" src={story.thumbnail} className="story-image" />
          <div className="story-lines">
            {story?.storyList?.map((storyLine, i) => (
              <div key={i} className="story-line">
                <p>{storyLine.line}</p>
                {storyLine.image && <img alt="story image" src={storyLine.image} />}
              </div>
            ))}
          </div>
          {email && (
            <div className="story-like" align="center">
              <button
                onClick={toggleLike}
                style={{
                  background: "none",
                  border: "none",
                  cursor: "pointer",
                }}
              >
                <FontAwesomeIcon
                  icon={faThumbsUp}
                  color={liked ? "blue" : "grey"}
                  size="2x"
                />
              </button>
            </div>
          )}
          <div className="story-likes-views" align="center">
            <p>
              <span>{story.views} views</span>
              <span> | </span>
              <span>{likes} likes</span>
            </p>
          </div>
          {email && (
            <div align="center">
              <Typography component="legend">Rate this story</Typography>
              <Rating
                name="simple-controlled"
                value={value}
                onChange={(event, newValue) => {
                  setRating(newValue);
                  setValue(newValue);
                }}
              />
            </div>
          )}
          <div>
            <Link className="story-goForward" to={`/quiz/${story._id}`}>
              <span>Take Quiz</span> <span> &#8594;</span>
            </Link>
          </div>
          <div className="story-export-options" align="center">
            <button onClick={handlePrint} className="export-button">
              Print Story
            </button>
            <button onClick={handleExportPDF} className="export-button">
              Export as PDF
            </button>
          </div>
          <CommentSection id={id} />
        </div>
      ) : (
        <EmptyList />
      )}

      <div className="floating-sidebar">
        <a
          href={`https://api.whatsapp.com/send?text=${encodeURIComponent(
            "Check out this story: " + currentUrl
          )}`}
          target="_blank"
          rel="noopener noreferrer"
          className="whatsapp-share"
        >
          <FontAwesomeIcon icon={faWhatsapp} size="2x" />
        </a>
        <a
          href={`https://twitter.com/intent/tweet?url=${encodeURIComponent(
            currentUrl
          )}&text=${encodeURIComponent("Check out this story!")}`}
          target="_blank"
          rel="noopener noreferrer"
          className="twitter-share"
        >
          <FontAwesomeIcon icon={faTwitter} size="2x" />
        </a>
        <a
          href="https://testflight.apple.com/v1/app/6670541417?build=156756462"
          target="_blank"
          rel="noopener noreferrer"
          className="apple-share"
        >
          <FontAwesomeIcon icon={faApple} size="2x" />
        </a>
      </div>
    </>
  );
};

export default OpenStory;
